<template>
  <v-main class="grey lighten-3 mt-5">
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
      <core-selector />
      <core-userinfo />
      <core-snackbar />
      <core-loader />
      <core-Cloader />
      <core-showbox />
      <core-AddToCard />
      <core-PurchaseProducts />
      <core-AttachBox />
      <core-EmailDetector />
      <core-SysExport />
    </div>
  </v-main>
</template>

<script>
export default {
  name: "CoreView",
  components: {
    CoreSysExport: () => import("@/components/core/SysExport"),
    CoreSelector: () => import("@/components/core/Selector"),
    CoreUserinfo: () => import("@/components/user-info/UserInfo"),
    CoreSnackbar: () => import("@/components/core/Snackbar"),
    CoreLoader: () => import("@/components/core/Loader"),
    CoreCloader: () => import("../core/CirculerLoader"),
    CoreShowbox: () => import("@/components/core/Showbox"),
    CoreAttachBox: () => import("@/components/core/AttachmentBox"),
    CoreEmailDetector: () => import("@/components/core/EmailDetector"),
    CoreAddToCard: () =>
      import("../messenger/MessageDashFiles/AddToCardDisplay"),
    CorePurchaseProducts: () =>
      import("../messenger/MessageDashFiles/PurchaseDisplay"),
  },
  metaInfo() {
    return {
      title: "Cleed.AI | Your Dashboard",
    };
  },
};
</script>
